// @ts-check

import { api } from '@/api'

/** @returns {Promise<UserResource>} */
export const getUser = async () => {
  const res = await api.get('user/details')
  return res.data
}

/**
 * @param {string} password
 * @returns {Promise<void>}
 */
export const checkPassword = async (password) => {
  await api.post('user/password/check', { password })
}
